import { c as _c } from "react/compiler-runtime";
import { Box, Separator, Flex, Heading, HStack, Image, Stack, Text, VStack } from '@chakra-ui/react';
import { CardCarousel } from '@src/components/sco/CardCarousel';
import { MobileBottomControl } from '@src/components/sco/CardCarousel/Controls/MobileBottomControl';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
export const LeadershipBlock: React.FC = () => {
  const $ = _c(60);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue([true, true, false, false, false]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isMobile = t0;
  const t1 = isMobile ? "xl" : "3xl";
  let t2;
  if ($[2] !== getBreakpointValue) {
    t2 = getBreakpointValue([4, 4, 10, 10, 10]);
    $[2] = getBreakpointValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      _light: "linear-gradient({colors.pink.700/50}, transparent, transparent, {colors.pink.700/50})",
      _dark: "linear-gradient({colors.pink.900}, transparent, transparent, {colors.pink.900})"
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Separator flex="1" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== getBreakpointValue) {
    t5 = getBreakpointValue(["xl", "2xl", "3xl"]);
    $[6] = getBreakpointValue;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <Text color="pink.fg" flexShrink="0" fontSize={t5} fontWeight={700} letterSpacing="wide" textAlign="center" textStyle="heading" textTransform="uppercase">Leadership</Text>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Separator flex="1" />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6) {
    t8 = <HStack align="center" gap={10} justify="center" width="full">{t4}{t6}{t7}</HStack>;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== getBreakpointValue) {
    t9 = getBreakpointValue(["column", "column", "row"]);
    $[13] = getBreakpointValue;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = isMobile ? 6 : 0;
  let t11;
  if ($[15] !== getBreakpointValue) {
    t11 = getBreakpointValue([4, 4, 8]);
    $[15] = getBreakpointValue;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== getBreakpointValue) {
    t12 = getBreakpointValue(["center", "center", "left"]);
    $[17] = getBreakpointValue;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== getBreakpointValue) {
    t13 = getBreakpointValue(["3xl", "4xl", "7xl"]);
    $[19] = getBreakpointValue;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t13) {
    t14 = <Heading color="red.fg" fontWeight={700} lineHeight={1} size={t13}>This is our Dream Job</Heading>;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== getBreakpointValue) {
    t15 = getBreakpointValue(["md", "lg"]);
    $[23] = getBreakpointValue;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  let t17;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <br />;
    t17 = <br />;
    $[25] = t16;
    $[26] = t17;
  } else {
    t16 = $[25];
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t15) {
    t18 = <Text color="red.fg/75" fontSize={t15} fontWeight={600}>Our goal in building this company was to spend all of our days sitting around helping Founders. It's awesome, and it never gets old. Working with Founders is the hardest and most inspiring work we could possibly do.{t16}{t17}So, thank you.</Text>;
    $[27] = t15;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t10 || $[30] !== t11 || $[31] !== t12 || $[32] !== t14 || $[33] !== t18) {
    t19 = <Flex align="center" direction="column" gap={4} justify="center" marginY={t10} paddingX={t11} textAlign={t12} width="full">{t14}{t18}</Flex>;
    $[29] = t10;
    $[30] = t11;
    $[31] = t12;
    $[32] = t14;
    $[33] = t18;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  let t21;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Box bgImage="radial-gradient(circle, {colors.red.fg/50}, transparent 70%)" height="700px" position="absolute" width="700px" />;
    t21 = <Image alt="Portrait of Wil Schroter" filter="drop-shadow(0 0 10px rgba(0, 0, 0, 0.35))" marginRight={10} objectFit="contain" src="/assets/graphics/about/wil-cutout-fade.png" width="full" zIndex={10} />;
    $[35] = t20;
    $[36] = t21;
  } else {
    t20 = $[35];
    t21 = $[36];
  }
  const t22 = isMobile ? 0 : undefined;
  const t23 = isMobile ? 4 : 0;
  const t24 = isMobile ? undefined : 12;
  const t25 = isMobile ? "full" : "240px";
  const t26 = isMobile ? 10 : 2;
  let t27;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Text color="red.fg" fontFamily="longform" fontStyle="italic">“The only thing I love more than building startups is helping a million Founders build theirs.”</Text>;
    $[37] = t27;
  } else {
    t27 = $[37];
  }
  let t28;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <VStack align="center" gap={0} justify="center"><Text color="colorPalette.fg" fontSize="sm" fontWeight={600}>Wil Schroter, Founder + CEO</Text><Text color="colorPalette.fg/70" fontSize="xs" fontWeight={600}>9 Startups, 6 exits, 32 Years</Text></VStack>;
    $[38] = t28;
  } else {
    t28 = $[38];
  }
  let t29;
  if ($[39] !== t22 || $[40] !== t23 || $[41] !== t24 || $[42] !== t25 || $[43] !== t26) {
    t29 = <Flex align="center" alignSelf="stretch" borderRadius="md" direction="column" justify="center" position="relative" width="full">{t20}{t21}<VStack align="center" backdropFilter="blur(10px)" bgColor="colorPalette.bg/75" borderRadius="xl" bottom={t22} gap={4} justify="flex-end" marginBottom={t23} padding={4} position="absolute" right="-12px" textAlign="center" top={t24} width={t25} zIndex={t26}>{t27}{t28}</VStack></Flex>;
    $[39] = t22;
    $[40] = t23;
    $[41] = t24;
    $[42] = t25;
    $[43] = t26;
    $[44] = t29;
  } else {
    t29 = $[44];
  }
  let t30;
  if ($[45] !== t19 || $[46] !== t29 || $[47] !== t9) {
    t30 = <Stack align="center" direction={t9} gap={0} justify="center" width="full">{t19}{t29}</Stack>;
    $[45] = t19;
    $[46] = t29;
    $[47] = t9;
    $[48] = t30;
  } else {
    t30 = $[48];
  }
  let t31;
  if ($[49] !== getBreakpointValue || $[50] !== isMobile) {
    t31 = isMobile ? <CardCarousel fade={false} spacing="0" visibleCards={[1]} controls={{
      top: false,
      bottom: MobileBottomControl
    }}><LeadershipCard alt="Ed Kang" imageUrl={require("@public/assets/people/ed.jpg").default.src} name="Ed Kang" subtitle="7 startups, 2 exits, 24 years" title="Chief Strategy Officer" /><LeadershipCard alt="Ryan Rutan" imageUrl={require("@public/assets/people/ryan.jpg").default.src} name="Ryan Rutan" subtitle="7 startups 4 exits, 27 years" title="Chief Marketing Officer" /><LeadershipCard alt="Ed Kang" imageUrl={require("@public/assets/people/gacka.jpg").default.src} name="Steve Gacka" subtitle="6 startups, 4 exits, 17 years" title="Chief Technology Officer" /></CardCarousel> : <VStack align="center" gap={4} justify="center" marginTop={-20} width="full"><HStack align="center" gap={4} justify="center" width="full"><Text color="pink.fg" fontSize={getBreakpointValue(["lg", "xl"])} fontWeight={600} opacity={1} whiteSpace="nowrap">Leadership Team</Text><Separator flex="1" /></HStack><HStack align="center" gap={4} justify="center" width="full"><LeadershipCard alt="Ed Kang" imageUrl={require("@public/assets/people/ed.jpg").default.src} name="Ed Kang" subtitle="7 startups, 2 exits, 24 years" title="Chief Strategy Officer" /><LeadershipCard alt="Ryan Rutan" imageUrl={require("@public/assets/people/ryan.jpg").default.src} name="Ryan Rutan" subtitle="7 startups, 4 exits, 27 years" title="Chief Marketing Officer" /><LeadershipCard alt="Ed Kang" imageUrl={require("@public/assets/people/gacka.jpg").default.src} name="Steve Gacka" subtitle="6 startups, 4 exits, 17 years" title="Chief Technology Officer" /></HStack></VStack>;
    $[49] = getBreakpointValue;
    $[50] = isMobile;
    $[51] = t31;
  } else {
    t31 = $[51];
  }
  let t32;
  if ($[52] !== t30 || $[53] !== t31) {
    t32 = <VStack align="start" gap={0} justify="center" maxWidth="container.xl" width="full">{t30}{t31}</VStack>;
    $[52] = t30;
    $[53] = t31;
    $[54] = t32;
  } else {
    t32 = $[54];
  }
  let t33;
  if ($[55] !== t1 || $[56] !== t2 || $[57] !== t32 || $[58] !== t8) {
    t33 = <VStack align="center" borderRadius={t1} boxShadow="inset 0 1px 0 rgba(255, 255, 255, 0.2)" height="full" justify="stretch" overflow="hidden" padding={t2} width="full" bgImage={t3}>{t8}{t32}</VStack>;
    $[55] = t1;
    $[56] = t2;
    $[57] = t32;
    $[58] = t8;
    $[59] = t33;
  } else {
    t33 = $[59];
  }
  return t33;
};
const LeadershipCard: React.FC<{
  imageUrl: string;
  alt: string;
  name: string;
  title: string;
  subtitle: string;
}> = t0 => {
  const $ = _c(16);
  const {
    imageUrl,
    alt,
    name,
    title,
    subtitle
  } = t0;
  let t1;
  if ($[0] !== alt || $[1] !== imageUrl) {
    t1 = <Image alt={alt} borderRadius="lg" boxShadow="lg" objectFit="contain" src={imageUrl} width="120px" />;
    $[0] = alt;
    $[1] = imageUrl;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== name) {
    t2 = <Text color="colorPalette.fg" fontSize="lg" fontWeight={600} opacity={1} whiteSpace="nowrap">{name}</Text>;
    $[3] = name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== title) {
    t3 = <Text color="pink.fg" fontSize="sm" fontWeight={600} opacity={1}>{title}</Text>;
    $[5] = title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== subtitle) {
    t4 = <Text color="red.fg" fontSize="sm" fontWeight={600} opacity={1}>{subtitle}</Text>;
    $[7] = subtitle;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <VStack align="start" gap={0} justify="center">{t2}{t3}{t4}</VStack>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t1 || $[14] !== t5) {
    t6 = <Stack align="center" bgColor="colorPalette.container" borderRadius="xl" boxShadow="lg" direction="row" gap={4} justify="start" padding={4} width="full">{t1}{t5}</Stack>;
    $[13] = t1;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};